import React from 'react';
import { ChildrenList } from './ChildrenList';
import { ChildAdd, ChildEdit } from './ChildAddEdit';
import { ChildShow } from './ChildShow';
import { WithRole } from '../common';
import { UserRole } from 'src/auth/types';
import NoAccess from '../common/Errors/NoAccess';
import { AdminGroup } from 'src/constants/roles';

export default {
    list: ChildrenList,
    show: (
        <WithRole roles={AdminGroup} orElse={<NoAccess />}>
            <ChildShow />
        </WithRole>
    ),
    create: (
        <WithRole roles={[UserRole.SYSTEM_ADMIN, UserRole.ADMIN, UserRole.METHODOLOGIST]} orElse={<NoAccess />}>
            <ChildAdd />
        </WithRole>
    ),
    edit: (
        <WithRole roles={AdminGroup} orElse={<NoAccess />}>
            <ChildEdit />
        </WithRole>
    )
};
